import { cn } from "@punchup/utils/cn";

export default function SubHeader1({
  children,
  className,
  responsive,
}: {
  children: React.ReactNode;
  className?: string;
  responsive?: boolean;
}) {
  const fontSize = responsive ? "text-[28px] md:text-[32px]" : "text-[32px]";
  return (
    <h2 className={cn(fontSize, "text-slate-gray-900 font-bold", className)}>
      {children}
    </h2>
  );
}
